
angular.module('app.filters')
.filter('source', ($filter) => {
    return (input) => {
        switch (input) {
            case "boxcaster":
                return "BoxCaster";
                break;
            case "rtmp":
                return "RTMP";
                break;
            case "recording":
                return "Simulated Live";
                break;
            default:
                return input;
                break;
        }
    };
});


// WEBPACK FOOTER //
// ./filters/source.js